import * as React from 'react';
import { get } from 'lodash-es';
import PaymentPlan from '@sunbit-dev/common/models/IPaymentPlan';

interface IPurchaseAction {
  setPurchase: (purchase: Partial<IChoosePlan>) => void;
  reset: () => void;
}

const INITIAL_SELECTED_PLAN = -1;

export interface IChoosePlan {
  amount: number;
  maxAmountApproved: number;
  paymentPlans?: PaymentPlan[];
  selectedPlanIndex: number;
  submit: (purchasePlanDiff: Partial<IChoosePlan>) => void;
  nextPage: () => void;
  goToCongratulationsScreen: () => void;
  amountRequested: number;
  offerId: number;
  debitCardLast4Digits?: string;
  expirationDate: string;
  referenceNumber?: string;
  shouldOfferMXFeature: boolean;
  recommendedMinAmountFinanced?: number;
}

const initialPurchase: IChoosePlan = {
  amount: 0,
  maxAmountApproved: 0,
  paymentPlans: [],
  selectedPlanIndex: INITIAL_SELECTED_PLAN,
  submit: () => {},
  nextPage: () => {},
  goToCongratulationsScreen: () => {},
  amountRequested: 0,
  offerId: 0,
  expirationDate: '1900-1-1',
  shouldOfferMXFeature: false,
  recommendedMinAmountFinanced: 0.0,
};

export const PurchaseContext = React.createContext<IChoosePlan>({
  ...initialPurchase,
});

export const PurchaseActionContext = React.createContext<IPurchaseAction>({
  setPurchase: () => {},
  reset: () => {},
});

const PurchaseContextProvider = (props) => {
  const [purchase, setPurchaseInner] = React.useState(initialPurchase);

  const setPurchase = (newPurchaseData: Partial<IChoosePlan>) => {
    const defaultPlanIndex = (get(newPurchaseData, ['paymentPlans'], []) as PaymentPlan[]).findIndex((e) => e.default);
    const userSelectedPlanIndex = get(newPurchaseData, 'selectedPlanIndex', purchase.selectedPlanIndex);
    const paymentPlans = get(newPurchaseData, 'paymentPlans', purchase.paymentPlans);

    let selectedPlanIndex;
    if (purchase.selectedPlanIndex === INITIAL_SELECTED_PLAN) selectedPlanIndex = defaultPlanIndex;
    else selectedPlanIndex = paymentPlans?.[userSelectedPlanIndex] ? userSelectedPlanIndex : paymentPlans?.length - 1;

    setPurchaseInner({ ...purchase, ...newPurchaseData, selectedPlanIndex });
  };

  const reset = () => {
    setPurchaseInner({ ...initialPurchase });
  };

  return (
    <PurchaseContext.Provider value={purchase}>
      <PurchaseActionContext.Provider value={{ setPurchase, reset }}>{props.children}</PurchaseActionContext.Provider>
    </PurchaseContext.Provider>
  );
};

export default PurchaseContextProvider;
